import { PriceCompareMessage } from '../../../../../types/PriceCompareMessage';

export const createPricesMap = (prices: PriceCompareMessage[]) => {
    const pricesMap: { [key: string]: { [key: string]: PriceCompareMessage[] } } = {};

    prices?.forEach((priceData) => {
        if (!pricesMap[priceData.portId]) {
            pricesMap[priceData.portId] = {};
        }
        if (!pricesMap[priceData.portId][priceData.category.toString()]) {
            pricesMap[priceData.portId][priceData.category.toString()] = [];
        }
        pricesMap[priceData.portId][priceData.category].push(priceData);
    });
    return pricesMap;
};
